<template>
  <v-container
    class="pa-0"
    :class="[$vuetify.breakpoint.xlOnly ? 'icons-container-xl' : 'icons-container-lg-down']"
  >
      <!-- <v-row no-gutters v-if="shipment.__typename === 'Shipment1PL'" class="flex-nowrap" :class="[$vuetify.breakpoint.xlOnly ? 'shipment--icons-xl' : 'shipment--icons-lg-down']">
        <v-col v-show="shipment.driver !== null">
          <user-icon @mouseover="isUserHovering = true" @mouseout="isUserHovering = false" size="17" class="custom-class user-icon mr-3"></user-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isUserHovering">{{shipment.driver}}</v-chip>
        </v-col>
        <v-col v-show="shipment.quoting !== null">
          <dollar-sign-icon @mouseover="isQuoteHovering = true" @mouseout="isQuoteHovering = false" size="17" class="custom-class quoting-icon"></dollar-sign-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isQuoteHovering">{{$t('quotes.' + shipment.quoting.quotingStatus)}}</v-chip>
        </v-col>
      </v-row>
      <v-row no-gutters v-show="shipment.__typename === 'Shipment1PL' && shipment.driver === null" class="flex-nowrap" :class="[$vuetify.breakpoint.xlOnly ? 'shipment--icons-xl' : 'shipment--icons-lg-down']">
        <v-col v-show="shipment.warnings !== null">
          <alert-triangle-icon @mouseover="isAlertHovering = true" @mouseout="isAlertHovering = false" size="17" class="custom-class alert-icon"></alert-triangle-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isAlertHovering">
            <span v-for="(warning, index) in shipment.warnings"
                  :key="index"
                  class="text-no-wrap">{{warning}}</span>
          </v-chip>
        </v-col>
      </v-row>

      <v-row no-gutters v-if="shipment.__typename === 'Shipment2PL'"  class="flex-nowrap" :class="[$vuetify.breakpoint.xlOnly ? 'shipment--icons-xl' : 'shipment--icons-lg-down']">
        <v-col v-show="shipment.driver !== null">
          <user-icon @mouseover="isUserHovering = true" @mouseout="isUserHovering = false" size="17" class="custom-class user-icon mr-3"></user-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isUserHovering">{{shipment.driver}}</v-chip>
        </v-col>
        <v-col v-show="shipment.warnings !== null">
          <alert-triangle-icon @mouseover="isAlertHovering = true" @mouseout="isAlertHovering = false" size="17" class="custom-class alert-icon"></alert-triangle-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isAlertHovering">
            <span v-for="(warning, index) in shipment.warnings"
                  :key="index"
                  class="text-no-wrap">{{warning}}</span>
          </v-chip>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="shipment.__typename === 'Shipment2PL'"  class="flex-nowrap" :class="[$vuetify.breakpoint.xlOnly ? 'shipment--icons-xl' : 'shipment--icons-lg-down']">
        <v-col v-show="shipment.carrier !== null">
          <v-icon @mouseover="isBusinessHovering = true" @mouseout="isBusinessHovering = false" size="14" color="white" class="company-icon mr-3">business</v-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isBusinessHovering">{{shipment.vehicleClass.organization.name}}</v-chip>
        </v-col>
        <v-col v-show="shipment.warnings !== null">
          <dollar-sign-icon @mouseover="isQuoteHovering = true" @mouseout="isQuoteHovering = false" size="17" class="custom-class quoting-icon"></dollar-sign-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isQuoteHovering">{{$t('quotes.' + shipment.quoting.quotingStatus)}}</v-chip>
        </v-col>
      </v-row>

      <v-row no-gutters v-if="shipment.__typename === 'ShipmentExpress' || shipment.__typename === 'ShipmentLTL' || shipment.__typename === 'Shipment3PL'" class="flex-nowrap" :class="[$vuetify.breakpoint.xlOnly ? 'shipment--icons-xl' : 'shipment--icons-lg-down']">
        <v-col v-show="shipment.carrier != null">
          <v-icon @mouseover="isBusinessHovering = true" @mouseout="isBusinessHovering = false" size="14" color="white" class="company-icon mr-3">business</v-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isBusinessHovering">{{shipment.carrier}}</v-chip>
        </v-col>
        <v-col v-show="shipment.quoting !== null">
          <dollar-sign-icon @mouseover="isQuoteHovering = true" @mouseout="isQuoteHovering = false" size="17" class="custom-class quoting-icon"></dollar-sign-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isQuoteHovering">{{$t('quotes.' + shipment.quoting.quotingStatus)}}</v-chip>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="shipment.__typename === 'ShipmentExpress' || shipment.__typename === 'ShipmentLTL' || shipment.__typename === 'Shipment3PL'" class="flex-nowrap" :class="[$vuetify.breakpoint.xlOnly ? 'shipment--icons-xl' : 'shipment--icons-lg-down']">
        <v-col v-show="shipment.warnings !==null">
          <alert-triangle-icon @mouseover="isAlertHovering = true" @mouseout="isAlertHovering = false" size="17" class="custom-class alert-icon"></alert-triangle-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isAlertHovering">
            <span v-for="(warning, index) in shipment.warnings"
                  :key="index"
                  class="text-no-wrap">{{warning}}</span>
          </v-chip>
        </v-col>
      </v-row>

      <v-row no-gutters v-if="shipment.__typename === 'NotTypedShipment'" :class="[$vuetify.breakpoint.xlOnly ? 'shipment--icons--no--type' : 'shipment--icons--no--type-lg-down']">
        <v-col v-show="shipment.quoting != null">
          <dollar-sign-icon @mouseover="isQuoteHovering = true" @mouseout="isQuoteHovering = false" size="17" class="custom-class quoting-icon"></dollar-sign-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isQuoteHovering">{{$t('quotes.' + shipment.quoting.quotingStatus)}}</v-chip>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="shipment.__typename === 'ShipmentCustom'" class="flex-nowrap" :class="[$vuetify.breakpoint.xlOnly ? 'shipment--icons-xl' : 'shipment--icons-lg-down']">
        <v-col v-show="shipment.carrier != null">
          <v-icon @mouseover="isBusinessHovering = true" @mouseout="isBusinessHovering = false" size="14" color="white" class="company-icon mr-3">business</v-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isBusinessHovering">{{shipment.carrier}}</v-chip>
        </v-col>
        <v-col v-show="shipment.quoting !== null">
          <dollar-sign-icon @mouseover="isQuoteHovering = true" @mouseout="isQuoteHovering = false" size="17" class="custom-class quoting-icon"></dollar-sign-icon>
          <v-chip small color="#555555" text-color="#FFFFFF" :class="[$vuetify.breakpoint.xlOnly ? 'icon-chip' : 'icon-chip-lg-down']" v-if="isQuoteHovering">{{$t('quotes.' + shipment.quoting.quotingStatus)}}</v-chip>
        </v-col>
      </v-row> -->
      <v-row
        no-gutters
      >
        <v-col
          cols="6"
        >
          <user-icon
            class="custom-class user-icon"
            size="17"
            :class="{'hidden': !isUserIconVisible}"
          />
        </v-col>
        <v-col
          cols="6"
        >
          <alert-triangle-icon
            class="custom-class alert-icon"
            :class="{'hidden': !isAlertIconVisible}"
            size="17"
          />
        </v-col>
        <v-col
          cols="6"
        >
        <v-tooltip
          right
          content-class="icon--tooltip"
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              size="14"
              class="company-icon"
              color="white"
              :class="{'hidden': !isBusinessIconVisible}"

            >
              business
            </v-icon>
          </template>
          <span>{{ businessIconText }}</span>
        </v-tooltip>
        </v-col><v-col
          cols="6"
        >
        <v-tooltip
          right
          content-class="icon--tooltip"
        >
          <template v-slot:activator="{ on }">
            <dollar-sign-icon
            v-on="on"
            class="custom-class quoting-icon"
            :class="{'hidden': !isQuotingIconVisible}"
            size="17"
          />
          </template>
          <span
            v-if="shipment.quoting != null"
          >
          {{$t('quotes.' + shipment.quoting.quotingStatus)}}
          </span>
        </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'IconsGroupByDay',
   components: {},
  props: {
    shipment: Object
  },
  data () {
    return {
        isUserHovering: false,
        isQuoteHovering: false,
        isBusinessHovering: false,
        isAlertHovering: false
    }
  },
  created () {},
  mounted () {},
  computed: {
    isUserIconVisible () {
      return false
    },
    isAlertIconVisible () {
      return false
    },
    isQuotingIconVisible () {
      return this.shipment.quoting != null
    },
    isBusinessIconVisible () {
      switch (this.shipment.type) {
        case 'TwoPL':
          return true
        case 'OnePL':
          return true
        default:
          return this.shipment.carrier != null
      }
    },
    businessIconText () {
      switch (this.shipment.type) {
        case 'TwoPL':
          return this.shipment.vehicleClass.organization.name
        case 'OnePL':
          return this.shipment.vehicle.organization.name
        default:
          return null
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.icons-container-xl {
  margin-left: -13px;
}
.icons-container-lg-down {
   margin-left: -16px;
}
.icon--tooltip {
  border-radius: 15px;
  background-color: #555555;
  height: 26px;
  line-height: 22px;
  min-width: 80px;
  text-align: center;
  font-size: 12px;
  padding: 2px;
  font-weight: 600;
}
.shipment--icons-xl {
  margin-left: 100px;
}
.shipment--icons-lg-down {
  margin-left: 100px;
}
.shipment--icons--no--type {
  margin-left: 100px;
}
.shipment--icons--no--type-lg-down {
  margin-left: 40px;
}
.user-icon {
  background-color: var(--v-wrld_blue-base);
  padding: 3px;
  color: white;
  border-radius: 100%;
  &.hidden {
    visibility: hidden;
  }
}
.alert-icon {
  color: var(--v-alert_red-base);
  &.hidden {
    visibility: hidden;
  }
}
.company-icon {
  background-color: var(--v-wrld_purple-base);
  padding: 2px;
  color: white;
  border-radius: 100%;
  margin-top: -10px;
  &.hidden {
    visibility: hidden;
  }
  // margin-right: 10px;
  // margin-left: 25px;
}
.quoting-icon {
  background-color: var(--v-wrld_orange-base);
  padding: 3px;
  color: white;
  border-radius: 100%;
  &.hidden {
    visibility: hidden;
  }
}
.icon-chip {
  position: absolute;
  font-size: 14px;
}
.icon-chip-lg-down {
  position: absolute;
  font-size: 12px;
}
</style>
